import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const InspectLoader = ({ isLoading }) => (
  <div
    data-test="inspect-loader"
    styleName={isLoading ? 'inspect-loader' : ''}
  />
);

InspectLoader.propTypes = {
  isLoading: PropTypes.bool,
};

export default InspectLoader;
